import React, { FC, useState } from "react";
import { Modal } from "react-bootstrap";
import MyIcon from "../Common/MyIcon";
import InfoIcon from "../../assets/icons/Icon_Library/application icons/general/movable.svg2";
import DetailsForSolutionModals from "./DetailsForSolutionModals";
import { SolutionCard } from "../Library/SolutionsCardList";
import {
  SolutionClientType,
  SolutionType,
} from "../store/slices/settingsSlice";

interface SolutionInfoModalProps {
  solution: SolutionType;
  clientSolution?: SolutionClientType;
}

const SolutionInfoModal: FC<SolutionInfoModalProps> = ({
  solution,
  clientSolution,
}) => {
  const [show, setShow] = useState<boolean>(false);

  return (
    <>
      <div onClick={() => setShow(true)} className="h-100">
        <SolutionCard solution={solution} clientSolution={clientSolution} />
      </div>
      <Modal size="lg" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="d-flex align-items-center svg-white">
              <MyIcon Icon={InfoIcon} width={30} />
              <span className="ms-3 fs-3 fw-bold">Solution Information</span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DetailsForSolutionModals
            solution={solution}
            clientSolution={clientSolution}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SolutionInfoModal;
